import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { StatusChip } from '@/components/ui/status-chip'
import { formatProvenance, type Provenance } from './provenance'

/**
 * The "i" every number/panel carries — hover to see source, query, observed_at,
 * freshness (docs/design/00-design-system.md §3.1). Stale data additionally gets
 * an inline stale chip; the chip is never hidden.
 */
export function ProvenanceChip({ provenance }: { provenance: Provenance }) {
  return (
    <span className="inline-flex items-center gap-1.5">
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className="cursor-help text-[10.5px] text-unknown"
            aria-label={formatProvenance(provenance)}
          >
            i
          </span>
        </TooltipTrigger>
        <TooltipContent>{formatProvenance(provenance)}</TooltipContent>
      </Tooltip>
      {provenance.stale && (
        <StatusChip status="unknown" stale>
          stale
        </StatusChip>
      )}
    </span>
  )
}
